import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { config } from '../../../CommonUtils/CommonURLS'
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios'
import allowNumbersOnly, { handlePaste } from '../../../CommonUtils/CommonValidations'
import Swal from 'sweetalert2'
import * as Yup from 'yup';
import { useSelector } from 'react-redux'
import { failureAlert, } from '../../../CommonUtils/SweetAlerts'
import { AC_YEAR_OLD, ERROR_MSG } from '../../../CommonUtils/contextVariables'
import { UseGetStatus } from '../../../CommonUtils/Commonstatus'

function WithdrawlofExistingCourses() {
    const [getData, setData] = useState([])
    const hasFetchedData = useRef(false)
    const coursesFlags = useSelector((state) => state?.commonMastersReducer?.coursesFlags);
    const validationSchema = Yup.object().shape({
        //isWithdrawCourses: Yup.string().required(ERROR_MSG),
        data: Yup.array().when('isWithdrawCourses', {
            is: 'true',
            then: Yup.array().of(
                Yup.object().shape({
                    courseWithdrawl: Yup.string().required(ERROR_MSG).nullable(),
                    courseWithdrawlReason: Yup.string().when('courseWithdrawl', {
                        is: "true",
                        then: Yup.string().required(ERROR_MSG).nullable(),
                        otherwise: Yup.string().notRequired(),
                    }),




                })
            ),
            otherwise: Yup.array().notRequired(),
        })
    });

    const formik = useFormik({
        initialValues: {
            isWithdrawCourses: '',
            data: [{
                withdrawNoOfSections: '',
                courseWithdrawl: '',
                courseWithdrawlReason: '',
                slno: ''
            }]
        },
        validationSchema: validationSchema,
        onSubmit: (val) => {
            if (
                val?.isWithdrawCourses === "null" ||
                val?.isWithdrawCourses === undefined ||
                val?.isWithdrawCourses === ""
            ) {
                Swal.fire({
                    title: 'Required Fields',
                    text: `Please Select 'Is college applying for Withdrawal of any Courses'.`,
                    icon: 'warning',
                    backdrop: false,
                    confirmButtonText: 'OK'
                });
                return;
            }

            let payload = [];

            if (val?.isWithdrawCourses === "false") {
                payload = val?.data.map(row => ({
                    ...row,
                    slno: row?.slno,
                    isWithdrawCourses: val?.isWithdrawCourses,
                    withdrawNoOfSections: '',
                    courseWithdrawl: '',
                    courseWithdrawlReason: '',
                }));
            } else {
                // Normal mapping for all rows
                payload = val?.data.map(row => ({
                    ...row,
                    slno: row?.slno,
                    isWithdrawCourses: val?.isWithdrawCourses,
                    withdrawNoOfSections: row?.withdrawNoOfSections,
                    courseWithdrawl: row?.courseWithdrawl,
                    courseWithdrawlReason: row?.courseWithdrawlReason,
                }));
            }


            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + `saveWithdrawCourses`
                    CommonAxiosPost(url, payload).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire({
                                text: res?.data?.sdesc,
                                icon: "success",
                                backdrop: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((refresh) => {
                                if (refresh.isConfirmed) {
                                    GetData();
                                    UseGetStatus();
                                }
                            })
                        } else {
                            failureAlert("Failed to submit")
                        }
                    })
                }
            })
        }
    });

    function GetData() {
        let url = config.url.API_URL + `getWithdrawcourses`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setData(res?.data?.getWithdrawcourses);
                res?.data?.getWithdrawcourses?.forEach((data, i) => {
                    formik?.setFieldValue(`data[${i}].withdrawNoOfSections`, data?.withdraw_no_of_sections);
                    formik?.setFieldValue(`data[${i}].courseWithdrawl`, data?.course_withdrawl?.toString() || '');
                    formik?.setFieldValue(`data[${i}].courseWithdrawlReason`, data?.course_withdrawl_reason);
                    formik?.setFieldValue(`data[${i}].slno`, data?.slno);

                })
            }
            else {
                setData([])
            }
        })
    }
    const ClearValues = () => {
        //   if (getData?.length === 0) {
        formik.setFieldValue('data', [
            {
                withdrawNoOfSections: '',
                courseWithdrawl: '',
                courseWithdrawlReason: ''
            }
        ]);
        //  }
    };
    useEffect(() => {
        formik?.setFieldValue('isWithdrawCourses', coursesFlags?.withdrawal_existing_courses_flag?.toString());
        if (!hasFetchedData.current) {
            GetData()
            hasFetchedData.current = true
        }
    }, [coursesFlags])
    const validateWithdrawNoOfSections = (value, approv_no_of_sections) => {
        console.log("value", value);

        // Check for missing input
        if (value === null || value === undefined || value === '') {
            return 'required';
        }

        // Explicitly check if value is 0
        if (parseInt(value) === 0) {
            return '0 is not a valid value';
        }

        // Check if value exceeds approved number of sections
        if (parseInt(value) > approv_no_of_sections) {
            return `Value must be less than or equal to ${approv_no_of_sections}`;
        }

        return undefined;
    };



    return (
        <>
            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit} onChange={formik.handleChange} className='affl-form'>
                    <h5>5. College Application for Withdrawal of Courses</h5>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className='form-control'>
                        <label htmlFor="isWithdrawCourses" className='me-2'>
                            Is college applying for Withdrawal of any Courses :
                        </label>
                        <div style={{ marginBottom: '10px' }}>
                            <Field as='select' name='isWithdrawCourses' className='form-control mt-2' style={{ width: 'auto' }}
                                onChange={(e) => {
                                    if (e?.target?.value === "false") { ClearValues(); }
                                }}><option value=''>--SELECT--</option><option value="true">Yes</option><option value="false">No</option>
                            </Field>
                            <ErrorMessage name="isWithdrawCourses" component="div" className="text-error" />
                        </div>
                    </div>
                    {formik.values.isWithdrawCourses === 'true' && getData.length > 0 && (
                        <>
                            <div className="table-responsive mt-3">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>Sno</th>
                                            <th>Academic Program Type</th>
                                            <th>Course /Program</th>
                                            <th>Branch /Combination</th>
                                            <th>Medium</th>
                                            <th>Intake Approved for {AC_YEAR_OLD}</th>
                                            <th>Accreditation Conferred (NBA/NAAC)</th>
                                            <th>Affiliation Valid up to</th>
                                            <th>Approved No. of sections</th>
                                            <th>Course Duration</th>
                                            <th>Withdrawal</th>
                                            <th>Reason</th>
                                            <th>No. of Sections being Withdrawn</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getData && getData?.map((ec, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <Field type="hidden" name={`data[${i}].slno`} />
                                                <td className='text-left'>{ec?.course_group_desc}</td>
                                                <td className='text-left'>{ec?.course_cat_name}</td>
                                                <td className='text-left'>{ec?.course_name}</td>
                                                <td>{ec?.name}</td>
                                                <td>{ec?.final_sanction_intake}</td>
                                                <td>{ec?.accredition}</td>
                                                <td>{ec?.affl_valid_upto ?? '-'}</td>
                                                <td>{ec?.approv_no_of_sections}</td>
                                                <td>{ec?.duration}</td>
                                                <td>
                                                    <Field as='select' name={`data[${i}].courseWithdrawl`} className='form-control'
                                                        onChange={(e) => {
                                                            formik.handleChange(e);
                                                            if (e.target.value === "false") {
                                                                formik.setFieldValue(`data[${i}].courseWithdrawlReason`, '');
                                                                formik.setFieldValue(`data[${i}].withdrawNoOfSections`, '');
                                                            }
                                                        }}
                                                    >
                                                        <option value="">--SELECT--</option>
                                                        <option value="true">Yes</option>
                                                        <option value="false">No</option>
                                                    </Field>
                                                    <ErrorMessage name={`data[${i}].courseWithdrawl`} className='text-error' component='div' />
                                                </td>
                                                <td>
                                                    {formik?.values?.data[i]?.courseWithdrawl == 'true' && (
                                                        <>
                                                            <Field type='text' name={`data[${i}].courseWithdrawlReason`} className='form-control' maxLength="150" />
                                                            <ErrorMessage name={`data[${i}].courseWithdrawlReason`} className='text-error' component='div' />
                                                        </>
                                                    )}
                                                </td>
                                                <td>
                                                    {formik?.values?.data[i]?.courseWithdrawl == 'true' && (
                                                        <>
                                                            <Field type='text' name={`data[${i}].withdrawNoOfSections`} className='form-control' maxLength='2'
                                                                validate={(value) => validateWithdrawNoOfSections(value, ec?.approv_no_of_sections)}
                                                                onKeyPress={(e) => { allowNumbersOnly(e) }} onPaste={(e) => handlePaste(e)} />
                                                            <ErrorMessage name={`data[${i}].withdrawNoOfSections`} className='text-error' component='div' />
                                                        </>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                    {getData.length > 0 || formik?.values?.isWithdrawCourses === 'false' ? (<>

                        <button type='submit' className='btn btn-success btn-sm float-end mt-3'>Submit</button><pre /><pre /><pre />
                    </>) : ((<center className='text-danger h5 pt-5'>***** No Data Found *****</center>))}

                </Form>
            </FormikProvider>
        </>
    )
}

export default WithdrawlofExistingCourses
